import i18n from "../localization/i18n";


const LANGUAGE_KEY = "app_language";

/**
 * Get saved language from localStorage or fallback to default
 */
export const getSavedLanguage = (): string => {
    const lang = localStorage.getItem(LANGUAGE_KEY);
    return lang || "en"; // fallback to English
};

/**
 * Change language and save to localStorage
 */
export const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem(LANGUAGE_KEY, lang);
};
